import { GraduationCap, Users, TrendingUp } from "lucide-react";

export function AdminStats({ stats }) {
  const items = [
    { icon: GraduationCap, label: "Students", count: stats.students, color: "text-[#FF3B30]" },
    { icon: Users, label: "Coaches", count: stats.coaches, color: "text-[#32D74B]" },
    { icon: TrendingUp, label: "Investors", count: stats.investors, color: "text-[#007AFF]" },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-12">
      {items.map((s) => (
        <div key={s.label} className="bg-[#111111] border border-[#262626] p-6" data-testid={`stat-${s.label.toLowerCase()}`}>
          <s.icon className={`w-6 h-6 ${s.color} mb-3`} />
          <p className="text-3xl font-heading text-white">{s.count}</p>
          <p className="text-xs uppercase tracking-[0.2em] text-[#A3A3A3] font-body mt-1">{s.label}</p>
        </div>
      ))}
    </div>
  );
}
